const axios = require("axios");

export const getContestId = async (seriesId : string) => {
  const { data } = await axios.get(`${process.env.REACT_APP_URL_HXROAPI}/contests/by-series/${seriesId}`);
  return data;
};

export const getRunningSeries = async () => {
  const { data } = await axios.get(process.env.REACT_APP_URL_HXROAPI + '/contestseries/running');
  return data;
};
